/**
 * Route + embed wrapper for the Document Repository designer (obj_type "K").
 *
 * Mirrors the other designers: full-page at
 * `/designers/document/:project/:objName`, or embedded in the workbench
 * "Design" tab via `embedProject` / `embedObjName`. The editor itself lives in
 * `document/DocumentDesignerPage` so the workbench can mount it without
 * pulling in routing.
 */

import { useParams } from 'react-router-dom'
import type { EmbeddedDesignerProps } from './embeddedDesigner'
import Editor from './document/DocumentDesignerPage'

export default function DocumentDesignerRoute(props: EmbeddedDesignerProps) {
  const params = useParams<{ project?: string; objName?: string }>()
  const project = props.embedded ? (props.embedProject || '') : (params.project || '')
  const objName = props.embedded ? (props.embedObjName || '') : (params.objName || '')

  if (!project || !objName) {
    return (
      <div style={{ padding: 24, fontSize: 14, color: 'var(--color-text-secondary)' }}>
        Select a document repository to design.
      </div>
    )
  }
  return <Editor project={project} objName={objName} {...props} />
}
